import { Eligibility } from '@home-diy-toolbox/web/common-types/refresh-base';
import { BatteryResultIds } from '@home-diy-toolbox/web/contentful';

export const getBatteryReplacementResult = (eligibity: Eligibility) => {
	return eligibity.batteryReplacement
		? BatteryResultIds.BATTERY_REPLACEMENT_FREE
		: BatteryResultIds.BATTERY_REPLACEMENT;
};
